<template>
    <div class="accountNotLoggedIn">
        <!-- VERIFICAÇÃO DE EMAIL DESATIVADA - manter para possível reativação
        <template v-if="isOpenVerificationEmail">
            <div class="accountNotLoggedIn_confirm" v-if="isOpenVerificationEmail">
                <p class="accountNotLoggedIn_confirm_title">{{ translateWord('Verificação') }}</p>
                <p class="accountNotLoggedIn_confirm_description">
                    {{ translateWord('Enviamos um e-mail com um código de verificação. Verifique seu e-mail, copie o código e insira-o no campo abaixo.') }}
                </p>

                <builderall-confirm-email :email="registerUser.email" :lang="lang" />
            </div>
        </template>
        -->
        
        <template v-if="!isViewLogin">
            
            <div class="accountNotLoggedIn_googleSignUp">
                <div id="g_id_onload"
                    :data-client_id="googleClientIdBa"
                    data-context="signup"
                    data-ux_mode="popup"
                    data-callback="callback"
                    data-auto_prompt="false">
                </div>
                
                <div class="social-buttons">
                    <div class="g_id_signin"
                        data-type="standard"
                        data-shape="rectangular"
                        data-theme="outline"
                        data-text="signup_with"
                        data-size="large"
                        :data-locale="langBrowser"
                        data-logo_alignment="left"
                        data-width="400"
                        data-ba-i="checkout-google-sign-up-button"
                        data-ba-group="checkout-auth"
                        data-ba-type="click"
                        >
                    </div>

                    <div class="office_register_google_submit"
                        data-ba-i="checkout-google-sign-up-submit"
                        data-ba-group="checkout-auth"
                        data-ba-type="submit">
                    </div>
                </div>
            </div>

            <!-- Type Account Europe -->
            <div v-if="isEurCurrency" class="accountNotLoggedIn_typeAccountEur">
                <div class="accountNotLoggedIn_typeAccountEur_container">
                    <div :class="{active: typeAccountEur.personal}" @click="changeTypeAccountEur('personal')" class="accountNotLoggedIn_typeAccountEur_type accountNotLoggedIn_typeAccountEur_business">{{ translateWord('Conta pessoal') }}</div>
                    <div :class="{active: typeAccountEur.business}" @click="changeTypeAccountEur('business')" class="accountNotLoggedIn_typeAccountEur_type accountNotLoggedIn_typeAccountEur_personal">{{ translateWord('Conta empresa') }}</div>
                </div>
            </div>

            <div class="row">
                <div class="col-24"><h1 class="accountNotLoggedIn_title">{{ translateWord('Novo cadastro') }}</h1></div>
            </div>

            <form id="formRegister" novalidate>
                <div class="row">
                    <div class="col-24">
                        <div class="mandatory">
                            <at-input name="name" :status="$v.registerUser.name.$dirty && $v.registerUser.name.$invalid ? 'error' : ''" v-model="$v.registerUser.name.$model" :placeholder="translateWord('Digite seu nome e sobrenome')">
                                <template #append>
                                    <span class="icon icon-user"></span>
                                </template>
                            </at-input>
                            <span>*</span>
                        </div>

                        <p class="invalidInputText" v-if="$v.registerUser.name.$dirty && $v.registerUser.name.$invalid">{{ translateWord('Coloque seu nome completo') }}</p>
                    </div>

                    <div class="col-24">
                        <div class="mandatory">
                            <at-input name="email" :status="$v.registerUser.email.$dirty && $v.registerUser.email.$invalid ? 'error' : ''" v-model="$v.registerUser.email.$model" :placeholder="translateWord('Seu E-mail')" type="email">
                                <template #append>
                                    <span class="icon icon-mail"></span>
                                </template>
                            </at-input>
                            <span>*</span>
                        </div>

                        <p class="invalidInputText" v-if="$v.registerUser.email.$dirty && $v.registerUser.email.$invalid">{{ translateWord('Coloque um e-mail valido') }}</p>
                    </div>

                    <div class="col-24 mandatory">
                        <at-input name="email" v-model="registerUser.emailConfirm" :placeholder="translateWord('Confirmar E-mail')" type="email">
                            <template #append>
                                <span class="icon icon-mail"></span>
                            </template>
                        </at-input>
                        <span>*</span>
                    </div>

                    <div class="col-24">
                        <div class="mandatory">
                            <at-input name="password" v-model="$v.registerUser.password.$model" :status="$v.registerUser.password.$dirty && $v.registerUser.password.$invalid ? 'error' : ''" type="password" :placeholder="translateWord('Sua Senha')">
                                <template #append>
                                    <span class="icon icon-unlock"></span>
                                </template>
                            </at-input>
                            <span>*</span>
                        </div>

                        <p class="invalidInputText" v-if="$v.registerUser.password.$dirty && $v.registerUser.password.$invalid">{{ translateWord('Mínimo 8 caracteres, 1 maiúscula, 1 número e 1 símbolo.') }}</p>
                    </div>

                    <div class="col-24">
                        <div class="mandatory">
                            <at-input name="repeatPassword" v-model="$v.registerUser.passwordConfirm.$model" :status="$v.registerUser.passwordConfirm.$dirty && $v.registerUser.passwordConfirm.$invalid ? 'error' : ''" :placeholder="translateWord('Confirmar Senha')" type="password">
                                <template #append>
                                    <span class="icon icon-unlock"></span>
                                </template>
                            </at-input>
                            <span>*</span>
                        </div>

                        <p class="invalidInputText" v-if="$v.registerUser.passwordConfirm.$dirty && $v.registerUser.passwordConfirm.$invalid">{{ translateWord('A confirmação deve ser igual à senha.') }}</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-10">
                        <at-select filterable v-model="registerUser.country" :placeholder="translateWord('País')">
                            <at-option v-for="(country, index) in countries" :key="index" :value="country.slug">{{ country.country }} ({{ country.iso_code }})</at-option>
                        </at-select>
                    </div>

                    <div v-if="isEurCurrency && typeAccountEur.business" class="col-14">
                        <at-input name="vatNumber" v-model="registerUser.vatNumber" :placeholder="translateWord('VAT Número')"></at-input>
                    </div>

                    <div :class="{'col-24': isEurCurrency && typeAccountEur.business}" class="col-14 mandatory">
                        <vue-tel-input :inputOptions="{placeholder: translateWord('Seu Telefone')}" :preferredCountries="['US', 'BR']" @input="changePhone">
                            <span slot="arrow-icon"><<</span>
                        </vue-tel-input>
                    </div>
                </div>

                <div class="accountNotLoggedIn_termsAndPrivacy">
                    <div class="accountNotLoggedIn_termsAndPrivacy_newsLatter">
                        <at-checkbox v-model="newsletter" name="newsletter">
                            <span>{{ translateWord('Envie-me e-mails com notícias e ofertas') }}</span>
                        </at-checkbox>
                    </div>

                    <div class="accountNotLoggedIn_termsAndPrivacy_privacy">
                        <at-checkbox v-model="privacy" name="privacy">
                            <a target="_blank" :href="getLinkPrivacy" :class="privacyClass">{{ translateWord('Eu aceito a politica de privacidade') }}</a>
                        </at-checkbox>
                    </div>

                    <div class="accountNotLoggedIn_termsAndPrivacy_terms">
                        <at-checkbox v-model="terms" name="terms">
                            <a target="_blank" :href="getLinkTerms">{{ translateWord('Eu aceito os termos de uso') }}</a>
                        </at-checkbox>
                    </div>
                </div>

                <input type="hidden" name="signup_type" id="signup_type" value="">
                <input type="hidden" name="token" id="token" value="">
            </form>

            <div class="accountNotLoggedIn_actions">
                <at-button class="btn_formWidth" @click.prevent="submitUiBenda" id="btnRegister" type="primary" :disabled="btnEnabledRegister">{{ translateWord('Criar nova conta') }}</at-button>

                <p class="accountNotLoggedIn_actions_login" @click.prevent="isViewLogin = true">{{ translateWord('Entrar com uma conta existente') }}</p>
            </div>
        </template>

        <template v-if="isViewLogin">
            <!-- Verificação de email para login -->
            <template v-if="isLoginEmailVerification">
                <div class="accountNotLoggedIn_confirm">
                    <p class="accountNotLoggedIn_confirm_title">{{ translateWord('Verificação') }}</p>
                    <p class="accountNotLoggedIn_confirm_description">
                        {{ translateWord('Enviamos um e-mail com um código de verificação. Verifique seu e-mail, copie o código e insira-o no campo abaixo.') }}
                    </p>
                    <builderall-confirm-email :email="loginOffice.email" :lang="lang" />
                </div>
            </template>

            <template v-else>
            <div class="accountNotLoggedIn_googleSignUp">
                <div id="g_id_onload"
                    :data-client_id="googleClientIdBa"
                    data-context="signin"
                    data-ux_mode="popup"
                    data-callback="callbackLogin"
                    data-auto_prompt="false"
                    style="display: none!important;">
                </div>
                
                <div class="social-buttons">
                    <div class="g_id_signin"
                        data-type="standard"
                        data-shape="rectangular"
                        data-theme="outline"
                        data-text="signin"
                        data-size="large"
                        data-logo_alignment="left"
                        :data-locale="langBrowser"
                        data-width="400"
                        data-ba-i="checkout-google-sign-up-button"
                        data-ba-group="checkout-auth"
                        data-ba-type="click"
                        >
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-24"><h1 class="accountNotLoggedIn_title">{{ translateWord('Efetuar login') }}</h1></div>
            </div>

            <div class="row">
                <div class="col-24">
                    <at-input name="email" :status="$v.loginOffice.email.$dirty && $v.loginOffice.email.$invalid ? 'error' : ''" v-model="$v.loginOffice.email.$model" :placeholder="translateWord('Seu E-mail')" type="email">
                        <template #append>
                            <span class="icon icon-mail"></span>
                        </template>
                    </at-input>

                    <p class="invalidInputText" v-if="$v.loginOffice.email.$dirty && $v.loginOffice.email.$invalid">{{ translateWord('Coloque um e-mail valido') }}</p>
                </div>

                <div class="col-24">
                    <at-input name="name" v-model="loginOffice.password" :placeholder="translateWord('Senha')" type="password">
                        <template #append>
                            <span class="icon icon-unlock"></span>
                        </template>
                    </at-input>
                </div>
            </div>
            <div class="accountNotLoggedIn_actions">
                <at-button class="btn_formWidth" type="primary" @click.prevent="login" :disabled="btnEnabledLogin">{{ translateWord('Logar') }}</at-button>

                <p v-if="!onlyLogin" class="accountNotLoggedIn_actions_login" @click.prevent="isViewLogin = false">{{ translateWord('Registrar uma nova conta') }}</p>
            </div>
            </template>
        </template>
    </div>
</template>

<script>
import Helper from '../../assets/js/helper';
import PixelAnalytics from '../../assets/js/PixelAnalytics';
import RecoverPassword from '../User/RecoverPassword';
import { email, required, sameAs } from 'vuelidate/lib/validators';

import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';

import { mapState, mapGetters, mapMutations } from 'vuex';

export default {
    name: "AccountNotLoggedIn",
    props: {
        onlyLogin: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            countries: [],
            registerUser: {
                name: '',
                email: '',
                emailConfirm: '',
                password: '',
                passwordConfirm: '',
                phone: '',
                country: '',
                iubendaConsent: '',
                vatNumber: null
            },
            loginOffice: {
                email: '',
                password: ''
            },
            terms: false,
            privacy: false,
            newsletter: false,
            isViewLogin: this.onlyLogin,
            isViewRecoverPassword: false,
            viewAlertRecoverPassword: false,
            alertTextRecoverPassword: '',
            privacyClass: '',
            typeAccountEur: {
                personal: true,
                business: false
            },
            lang: Helper.convertSigla(Helper.getLangBrowser()),
            langBrowser: Helper.getLangBrowser(),
            // isOpenVerificationEmail: false,  // VERIFICAÇÃO DE EMAIL DESATIVADA
            // verificationEmailSuccess: false, // VERIFICAÇÃO DE EMAIL DESATIVADA
            isLoginEmailVerification: false,
            googleClientIdBa: '953291066922-01dm8v3fgeu2hcogacken435sa39jh1s.apps.googleusercontent.com',
            googleClientIdBaLogin: '92291654410-oj743mf3giufsqgrh49tevpbnlv9f0m9.apps.googleusercontent.com',
            // Google Sign-Up
            googleSignUp: {
                isGoogleSignUp: false,
                token: null
            },
            // Google Sign-In
            googleSignIn: {
                isGoogleSignIn: false,
                token: null
            }
        }
    },
    validations: {
        registerUser:{
            name: { fullName: (value) => /^[a-zA-Z]{2,}\s+([a-zA-Z\.]{2,})?.*([a-zA-Z\.]{2,})$.*/g.test(value) },
            email: {
                required, email
            },
            password: {
                required,
                strongPassword: (value) => /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{8,}$/.test(value)
            },
            passwordConfirm: {
                required,
                passwordConfirm: sameAs(function () {
                    return this.registerUser.password
                })
            }
        },
        loginOffice:{
            email: {
                required, email
            }
        }
    },
    async created(){        
        if(['dev', 'test'].includes(Helper.getEnvs().env)){
            this.registerUser.vatNumber = 'EL078909371';
        }

        if(PixelAnalytics.fbData.accessToken){
            let pixelFbInitiateRegistration = await generateFacebookEventId('InitiateRegistration');

            sendInitiateRegistrationEvent(
                PixelAnalytics.fbData.accessToken,
                PixelAnalytics.fbData.id,
                PixelAnalytics.fbData.funnelsDomain,
                pixelFbInitiateRegistration,
                PixelAnalytics.fbData.ur,
                PixelAnalytics.fbData.subdomain
            );
        }

        this.insertUiBenda();

        this.countries = (await this.$httpOffice.get(`${this.endpointOffice.SUBSIDIARIES}`)).data.data;

        this.firstListCountries();
        this.insertScriptGoogleSingUp();
        this.insertScriptGoogleSignIn();
        // this.insertScriptIntelligence(); // VERIFICAÇÃO DE EMAIL DESATIVADA
    },
    computed: {
        ...mapState([
            'endpointOffice',
            'localeUser',
            'userFather',
            'isPlan'
        ]),
        ...mapGetters([
            'translateWord' ,
            'getAllParamsUrl',
            'product',
            'hasBundlePlan'
        ]),
        btnEnabledRegister(){
            return this.$v.registerUser.email.$invalid || this.$v.registerUser.name.$invalid || this.registerUser.name == '' || this.registerUser.email == '' || this.$v.registerUser.password.$invalid || this.$v.registerUser.passwordConfirm.$invalid || !this.terms || !this.privacy ? true : false;
        },
        btnEnabledLogin(){
            return this.loginOffice.email == '' || this.loginOffice.password == '' ? true : false;
        },
        isEurCurrency(){
            return this.product && this.product.isTheCurrency && this.product.isTheCurrency.eur;
        },
        getLinkTerms(){
            let lang = Helper.convertSigla(Helper.getLangBrowser());

            switch(lang){
                case 'en': return 'https://builderall.com/terms-of-use'; break;
                case 'pt': return 'https://br.builderall.com/termos-uso'; break;
                case 'es': return 'https://es.builderall.com/terminos-de-uso'; break;
                case 'it': return 'https://it.builderall.com/termini-di-uso'; break;
                case 'fr': return 'https://fr.builderall.com/conditions-d-utilisation'; break;
                case 'de': return 'https://builderall.de/nutzungsbedingungen'; break;
                case 'nl': return 'https://nl.builderall.com/algemene-gebruiksvoorwaarden'; break;
                case 'pl': return 'https://pl.builderall.com/warunki-uytkowania-builderall'; break;
                case 'iw': return 'https://il.builderall.com/terms-of-use'; break;
                default: return 'https://builderall.com/terms-of-use';
            }
        },
        getLinkPrivacy(){
            let lang = Helper.convertSigla(Helper.getLangBrowser());
            let link = null;

            switch(lang){
                case 'en': link = 'https://www.iubenda.com/privacy-policy/15328257/legal'; break;
                case 'pt': link = 'https://www.iubenda.com/privacy-policy/36736122'; break;
                case 'es': link = 'https://www.iubenda.com/privacy-policy/19349540'; break;
                case 'it': link = 'https://www.iubenda.com/privacy-policy/57742374'; break;
                case 'fr': link = 'https://www.iubenda.com/privacy-policy/12277444'; break;
                case 'de': link = 'https://www.iubenda.com/privacy-policy/76100068'; break;
                case 'nl': link = 'https://www.iubenda.com/privacy-policy/25723324'; break;
                case 'pl': link = 'https://pl.builderall.com/polityka-prywatnoci'; break;
                case 'iw': link = 'https://il.builderall.com/privacy-policy'; break;
                default: link = 'https://builderall.com/privacy-policy'; break;
            }

            let iubendaLangs = ['en','pt','es','it','fr','de','nl'];
            if(iubendaLangs.includes(lang)) {
                this.privacyClass = 'iubenda-nostyle iubenda-noiframe iubenda-embed iubenda-noiframe';

                let script  = document.createElement('script');
                script.setAttribute('type', 'text/javascript');
                script.setAttribute('src', 'https://cdn.iubenda.com/iubenda.js');
                document.head.appendChild(script);
            }

            return link;
        },
    },
    methods: {
        ...mapMutations([
            'enabledFullScreenLoading',
            'impact/lead',
        ]),
        changePhone(phone, phoneCompleted){
            this.registerUser.phone = `${phoneCompleted.country.dialCode} ${phone}`;
        },
        changeTypeAccountEur(type){
            this.typeAccountEur = Object.fromEntries(Object.entries(this.typeAccountEur).map((value, key) => [value[0], false]));

            this.typeAccountEur[type] = true;
        },
        async register(){
            try{
                let dataRegister = {};

                // Verifica se é cadastro via Google Sign-Up
                let productId = this.product && this.product.id ? this.product.id : null;

                if(this.googleSignUp.isGoogleSignUp){
                    dataRegister = {
                        signup_type: 'google',
                        token: this.googleSignUp.token,
                        tracking_origin: window.location.hostname,
                        tracking_params: `p1=rd&p2=https://${window.location.hostname}${window.location.search.replace('?', '&')}`,
                        form_origin: 'ba-gateway',
                        id_plan: productId,
                        receive_email: 'NO',
                        cadastro_termos_de_uso: 1,
                        cadastro_termos_de_privacidade: 1,
                    };
                } else {
                    dataRegister = {
                        cadastro_nome: this.registerUser.name,
                        cadastro_email: this.registerUser.email,
                        cadastro_senha: this.registerUser.password,
                        cadastro_telefone: this.registerUser.phone,
                        subsidiary: this.registerUser.country,
                        tracking_origin: window.location.hostname,
                        tracking_params: `p1=rd&p2=https://${window.location.hostname}${window.location.search.replace('?', '&')}`,
                        iubenda_consent: this.registerUser.iubendaConsent,
                        form_origin: 'ba-gateway',
                        id_plan: productId,
                        receive_email: this.newsletter ? 'YES' : 'NO',
                        cadastro_termos_de_uso: this.terms ? 1 : 0,
                        cadastro_termos_de_privacidade: this.privacy ? 1 : 0,
                    };
                }

                let aid = Helper.getAidOffice() || this.$route.query.aid || this.userFather.id || null;
                let tagInternals = this.$route.query.taginternals || null;

                let sd = this.$route.query.sd || 'checkout';
                dataRegister.tracking_params += `&sd=${sd}`;

                if(aid) dataRegister['cadastro_aid'] = aid;
                if(tagInternals) dataRegister['taginternals'] = tagInternals;
                if(this.registerUser.vatNumber && !this.googleSignUp.isGoogleSignUp) dataRegister['vat_number'] = this.registerUser.vatNumber;


                let productTitle = this.product && this.product.title ? this.product.title : '';
                let itemName = (this.isSponsorBuilderall ? 'Direct-Purchase: ' : 'Affiliate-Purchase: ') + productTitle;
                let eventName = {
                    lead: 'lead'
                };
                let campaign = this.$route.query['campaign'] ? (this.$route.query['campaign']).toString().toUpperCase() : null;

                let registerUser = (await this.$httpOffice.post(`${Helper.getUrlOffice('office/create')}${this.getAllParamsUrl(false)}`, Helper.serialize(dataRegister), {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })).data;
                
                if(registerUser.hasOwnProperty('reason') && registerUser['reason'] == 'email_already_registered'){
                    this.enabledFullScreenLoading({status: false});
                    this.$Notify.info(this.translateWord('Opsss... Este e-mail já está cadastrado. Efetue o login'));

                    // this.isOpenVerificationEmail = false; // VERIFICAÇÃO DE EMAIL DESATIVADA
                    if(this.googleSignUp.isGoogleSignUp) this.isViewLogin = true;

                    return;
                }

                if(registerUser.hasOwnProperty('error') && registerUser['error'] == 'email_already_exists'){
                    this.enabledFullScreenLoading({status: false});
                    this.$Notify.info(this.translateWord('Opsss... Este e-mail já está cadastrado. Efetue o login'));

                    // this.isOpenVerificationEmail = false; // VERIFICAÇÃO DE EMAIL DESATIVADA
                    if(this.googleSignUp.isGoogleSignUp) this.isViewLogin = true;

                    return;
                }
                
                if(registerUser['type'] == 'success') {
                    PixelAnalytics.addDataLayer('NewRegister');

                    this['impact/lead']({
                        id: registerUser['user']['id'],
                        email: registerUser['user']['email']
                    });

                    if(PixelAnalytics.fbData.accessToken){
                        let pixelFbLead = await generateFacebookEventId('Lead');
                        
                        await sendLeadEvent(
                            PixelAnalytics.fbData.accessToken,
                            PixelAnalytics.fbData.id,
                            PixelAnalytics.fbData.funnelsDomain,
                            pixelFbLead,
                            Helper.firstName(this.registerUser.name),
                            Helper.lastName(this.registerUser.name),
                            this.registerUser.email,
                            PixelAnalytics.fbData.ur,
                            PixelAnalytics.fbData.subdomain
                        );
                    }

                    if(campaign){
                        itemName = `(C-${campaign}) ` + itemName;
                        eventName.lead = `C_${campaign}__${eventName.lead}`;
                    }

                    gtag('event', eventName.lead, { hitType: 'event', eventAction: 'click'});

                    this.enabledFullScreenLoading({status: true, text: this.translateWord('Cadastro feito com sucesso')});

                    if(this.product && this.product.title){
                        PixelAnalytics.createEventPixel('fb', 'Lead', {
                            content_name: this.product.title,
                            currency: this.product.currency,
                            value: this.product.amountCoupon ? this.product.amountCoupon : this.product.amount
                        });

                        PixelAnalytics.createEventPixel('tt', 'Lead', {
                            content_name: this.product.title,
                            currency: this.product.currency,
                            email: this.registerUser.email,
                            value: (this.product.amountCoupon ? this.product.amountCoupon : this.product.amount) || 0
                        });
                    }

                    setTimeout(() => window.location.reload() , 2000);

                    // if(this.hasBundlePlan){
                    //     setTimeout(() => this.$emit('bundle-plan:registration-success'), 2000);
                    // } else {
                    //     setTimeout(() => window.location.reload() , 2000);
                    // }
                    
                    return;
                }

                PixelAnalytics.addDataLayer('RegistrationFailure');

                this.enabledFullScreenLoading({status: false});
                this.$Notify.info(this.translateWord('Opsss... Infelizmente ocorreu um erro ao criar sua conta na Builderall, favor tente mais tarde!'));
                // this.isOpenVerificationEmail = false; // VERIFICAÇÃO DE EMAIL DESATIVADA
                if(this.googleSignUp.isGoogleSignUp) this.isViewLogin = true;
            }catch(error){
                // this.isOpenVerificationEmail = false; // VERIFICAÇÃO DE EMAIL DESATIVADA

                console.log('Error:', error);
                console.log('Response:', error.response);

                PixelAnalytics.addDataLayer('RegistrationFailure');

                this.enabledFullScreenLoading({status: false});

                if(error.response && error.response.data && error.response.data.reason === 'email_already_registered'){
                    this.$Notify.info(this.translateWord('Opsss... Este e-mail já está cadastrado. Efetue o login'));
                    if(this.googleSignUp.isGoogleSignUp) this.isViewLogin = true;
                    return;
                }

                this.$Notify.info(this.translateWord('Opsss... Infelizmente ocorreu um erro ao criar sua conta na Builderall, favor tente mais tarde!'));
                if(this.googleSignUp.isGoogleSignUp) this.isViewLogin = true;
            }
        },
        async login(){
            this.enabledFullScreenLoading({status: true, text: this.translateWord('Aguarde efetuando login')});

            try{
                let dataLogin = {};

                if(this.googleSignIn.isGoogleSignIn){
                    dataLogin = {
                        login_type: 10,
                        token: this.googleSignIn.token
                    };
                } else {
                    dataLogin = {
                        email: this.loginOffice.email,
                        senha: this.loginOffice.password
                    };
                }

                let loginUser = (await this.$httpOffice.post(this.endpointOffice.LOGIN, Helper.serialize(dataLogin), {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })).data;

                if(loginUser['type'] == 'success') {
                    PixelAnalytics.addDataLayer('SuccessfullLoggedIn');

                    this.enabledFullScreenLoading({status: true, text: this.translateWord('Login feito com sucesso')});

                    window.location.reload();

                    return this.$emit('new-register:login-success', true);
                }

                if(loginUser['type'] == 'email-unconfirmed') {
                    this.enabledFullScreenLoading({status: false});
                    this.isLoginEmailVerification = true;
                    this.listenLoginEmailVerification();
                    return;
                }

                PixelAnalytics.addDataLayer('FailedToLogin');
                
                this.enabledFullScreenLoading({status: false});
                this.$Notify.info(this.translateWord('Opsss... Infelizmente ocorreu um erro ao logar no office, favor tente mais tarde!'));
                console.log(loginUser);
                
            }catch(error){
                
                PixelAnalytics.addDataLayer('FailedToLogin');
                this.enabledFullScreenLoading({status: false});
                this.$Notify.info(this.translateWord('Opsss... Infelizmente ocorreu um erro ao logar no office, favor tente mais tarde!'));
                
                console.log(error);
            }
        },
        listenLoginEmailVerification(){
            document.addEventListener("builderall-confirm-email", (event) => {
                if(!event.detail.status){
                    return this.$Notify.info({message: this.translateWord('Código inválido'), duration: 0});
                }

                if(event.detail.status && ['email_already_verified', 'correct_code'].includes(event.detail.slug)){
                    this.isLoginEmailVerification = false;
                    this.login();
                }
            });
        },
        backRecoverPassword({status, email}){
            this.viewAlertRecoverPassword = false;

            //Quando usuario clicar em voltar.
            if(!status) {
                this.isViewLogin = true;
                this.isViewRecoverPassword = false;
                return;
            }

            this.alertTextRecoverPassword = this.translateWord('E-mail enviado com sucesso para redefinir senha. {0}', [email]);
            this.isViewLogin = true;
            this.isViewRecoverPassword = false;
            this.viewAlertRecoverPassword = true;
        },
        insertUiBenda(){
            _iub.cons_instructions.push([
                "init", {api_key: Helper.getEnvs().uiBendaKeys.publicKey}
            ]);

            let script  = document.createElement('script');
            script.setAttribute('type', 'text/javascript');
            script.setAttribute('src', 'https://cdn.iubenda.com/cons/iubenda_cons.js');
            document.head.appendChild(script);
        },
        submitUiBenda(){
            this.enabledFullScreenLoading({status: true, text: this.translateWord('Aguarde, estamos realizando seu cadastro')});

            if(!this.terms){
                this.enabledFullScreenLoading({status: false});
                this.$Notify.info(this.translateWord('É necessario aceitar os termos de uso para realizar o cadastro'))
                return;
            }

            if(this.registerUser.email != this.registerUser.emailConfirm){
                this.enabledFullScreenLoading({status: false});
                this.$Notify.info(this.translateWord('O E-mail de confirmação esta incorreto'));
                return;
            }

            if(this.registerUser.password != this.registerUser.passwordConfirm){
                this.enabledFullScreenLoading({status: false});
                this.$Notify.info(this.translateWord('Sua confirmação de senha esta incorreta'));
                return;
            }

            if(this.isEurCurrency && this.typeAccountEur.business && !this.registerUser.vatNumber){
                this.enabledFullScreenLoading({status: false});
                this.$Notify.info(this.translateWord('Para continuar o cadastro com uma conta empresa, favor inserir um número de VAT válido.'));
                return;
            }

            if(this.isEurCurrency && this.typeAccountEur.business && !Helper.validateVat(this.registerUser.vatNumber)){
                this.enabledFullScreenLoading({status: false});
                this.$Notify.info(this.translateWord('O Número de VAT {0} não é um formato válido. Favor verificar o número e tente novamente.', [this.registerUser.vatNumber]));
                return;
            }

            //Dispara request para o Iubenda em best-effort: se responder, grava o consent;
            //se falhar/CDN indisponivel, o cadastro segue normalmente sem travar
            try {
                if(typeof _iub !== 'undefined' && _iub.cons_instructions){
                    _iub.cons_instructions.push(['submit',
                        {
                            submitElement: document.getElementById('btnRegister'),
                            form: {
                                selector: document.getElementById('formRegister'),
                                map: {
                                    subject: {
                                        full_name: 'name', // name
                                        email: 'email'   // name
                                    },
                                    preferences: {
                                        term: 'terms',
                                        privacy_policy: 'privacy'
                                    },
                                    exclude: ['password']
                                }
                            },
                            consent: {
                                legal_notices: [
                                    {
                                        identifier: 'terms'
                                    },
                                    {
                                        identifier: 'privacy_policy'
                                    },
                                    {
                                        identifier: 'cookie_policy'
                                    }
                                ],
                            },
                        },
                        {
                            success: (response) => {
                                this.registerUser.iubendaConsent = response.status == 200 ? response.responseText : JSON.stringify(response);
                            },
                            error: (response) => {
                                this.registerUser.iubendaConsent = JSON.stringify(response);
                            }
                        }
                    ]);
                }
            } catch(e) {
                console.warn('[Iubenda] Falha ao enviar consent, prosseguindo com cadastro:', e);
            }

            this.register();
        },
        firstListCountries(){
            let [countryUs, countryBr] = this.countries.filter((country, index) => {
                if(country.iso_code == 'US' || country.iso_code == 'BR'){
                    this.countries.splice(index, 1);
                    return true;
                }
            });

            this.countries.unshift(countryUs);
            this.countries.unshift(countryBr);
        },
        // VERIFICAÇÃO DE EMAIL DESATIVADA - manter para possível reativação
        // openConfirmEmail(){
        //     this.isOpenVerificationEmail = true;
        //     this.enabledFullScreenLoading({status: false});
        //
        //     document.addEventListener("builderall-confirm-email", (event) => {
        //         if(!event.detail.status){
        //             return this.$Notify.info({message: 'Código inválido', duration: 0});
        //         }
        //
        //         if(event.detail.status && ['email_already_verified', 'correct_code'].includes(event.detail.slug)){
        //             this.isOpenVerificationEmail = false;
        //             this.verificationEmailSuccess = true;
        //             return this.confirmEmailSuccess();
        //         }
        //     });
        // },
        // confirmEmailSuccess(){
        //     this.enabledFullScreenLoading({status: true, text: 'Finalizando cadastro'});
        //     this.register();
        // },
        insertScriptGoogleSingUp(){
            window.callback = (response) => {
                document.querySelector('.office_register_google_submit').click();

                this.googleSignUp.isGoogleSignUp = true;
                this.googleSignUp.token = response.credential;
                this.enabledFullScreenLoading({status: true, text: 'Completing registration'});
                this.register();
            };

            let script  = document.createElement('script');
            script.setAttribute('src', 'https://accounts.google.com/gsi/client');
            script.setAttribute('async', '');
            script.setAttribute('defer', '');
            script.onload = () => {
                if(this.isViewLogin){
                    this.renderGoogleButtonLogin();
                } else {
                    this.renderGoogleButton();
                }
            };
            document.body.appendChild(script);
        },
        renderGoogleButton(){
            if (typeof google !== 'undefined' && google.accounts && google.accounts.id) {
                google.accounts.id.initialize({
                    client_id: this.googleClientIdBa,
                    callback: window.callback,
                    context: 'signup',
                    ux_mode: 'popup',
                    auto_select: false
                });

                const buttonElement = document.querySelector('.g_id_signin');
                if (buttonElement) {
                    google.accounts.id.renderButton(buttonElement, {
                        type: 'standard',
                        shape: 'rectangular',
                        theme: 'outline',
                        text: 'signup_with',
                        size: 'large',
                        locale: this.langBrowser,
                        logo_alignment: 'left',
                        width: 400
                    });
                }
            }
        },
        insertScriptGoogleSignIn(){
            window.callbackLogin = (response) => {
                this.googleSignIn.isGoogleSignIn = true;
                this.googleSignIn.token = response.credential;
                this.enabledFullScreenLoading({status: true, text: 'Completing login'});
                this.login();
            };
        },
        renderGoogleButtonLogin(){
            if (typeof google !== 'undefined' && google.accounts && google.accounts.id) {
                google.accounts.id.initialize({
                    client_id: this.googleClientIdBa,
                    callback: window.callbackLogin,
                    context: 'signin',
                    ux_mode: 'popup',
                    auto_select: false
                });

                const buttonElement = document.querySelector('.g_id_signin');
                if (buttonElement) {
                    google.accounts.id.renderButton(buttonElement, {
                        type: 'standard',
                        shape: 'rectangular',
                        theme: 'outline',
                        text: 'signin',
                        size: 'large',
                        locale: this.langBrowser,
                        logo_alignment: 'left',
                        width: 400
                    });
                }
            }
        },
        // VERIFICAÇÃO DE EMAIL DESATIVADA - manter para possível reativação
        // insertScriptIntelligence(){
        //     let script  = document.createElement('script');
        //     script.setAttribute('src', Helper.getEnvs().urlIntelligence + '/dist/capture-min.js');
        //     document.body.appendChild(script);
        // }
    },
    watch: {
        isViewLogin(newValue) {
            this.$nextTick(() => {
                if (newValue === true) {
                    // Mudou para login, renderiza botão de login
                    this.renderGoogleButtonLogin();
                } else {
                    // Mudou para cadastro, renderiza botão de cadastro
                    this.renderGoogleButton();
                }
            });
        }
    },
    components: {
        RecoverPassword,
        VueTelInput
    }
}
</script>

<style lang="scss">
    @import "../../scss/mixins";
    
    .accountNotLoggedIn_googleSignUp{
        display: flex;
        justify-content: center;
        margin-bottom: 20px;
        margin-top: 12px;
    }

    .accountNotLoggedIn_confirm{
        margin-top: 20px;
        text-align: center;
    }
    .accountNotLoggedIn_confirm_title{
        font-weight: bold;
        color: var(--black);
    }
    .accountNotLoggedIn_confirm_description{
        font-size: 0.8em;
        margin-bottom: 30px;

        @media (max-width: 767px) {
            font-size: 16px;
        }
    }

    .accountNotLoggedIn_typeAccountEur{
        display: flex;
        justify-content: center;
        margin-bottom: 28px;
    }
    .accountNotLoggedIn_typeAccountEur_container{
        display: flex;
        text-align: center;
        padding: 6px;
        border: 1px solid var(--gray-500);
        border-radius: 50px;
        font-size: 0.6em;
    }
    .accountNotLoggedIn_typeAccountEur_type{
        margin-right: 12px;
        padding: 6px 30px;
        cursor: pointer;
        font-weight: 600;
        color: var(--gray-500);

        &.active{
            background: var(--blue);
            color: var(--white);
            border-radius: 50px;
        }

        &:last-child{
            margin-right: 0px;
        }
    }

    .accountNotLoggedIn_title{
        font-size: 1.2em;
        color: var(--black);
        text-align: left;
        font-weight: 600;
        margin-bottom: 8px;
    }

    .accountNotLoggedIn .at-checkbox__inner{
        width: 12px;
        height: 12px;

        @media (max-width: 767px) {
            width: 20px;
            height: 20px; 
        }
    }
    .accountNotLoggedIn_termsAndPrivacy_newsLatter{
        & span{
            font-size: 9px;
            color: var(--gray-500);
        }
    }
    .accountNotLoggedIn_termsAndPrivacy{
        display: flex;
        justify-content: center;
        margin: 20px 5px;

        & .at-checkbox{
            display: flex;
        }

        & .at-checkbox__label{
            font-size: inherit;
        }

        @media (max-width: 767px) {
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin: 10px 0;

            .at-checkbox{
                margin-bottom: 10px;
            }
        }
    }
    .accountNotLoggedIn_termsAndPrivacy_terms,
    .accountNotLoggedIn_termsAndPrivacy_privacy,
    .accountNotLoggedIn_termsAndPrivacy_newsLatter{
        margin-right: 10px;

        & a{
            font-size: 9px;
        
            @media (max-width: 767px) {
                font-size: 12px;
            }
        }

        & span{
            font-size: 9px;
        
            @media (max-width: 767px) {
                font-size: 12px;
            }
        }
    }

    .accountNotLoggedIn_actions{
        text-align: center;
    }
    .accountNotLoggedIn_actions_login{
        font-size: 0.8em;
        margin-top: 20px;
        font-weight: 600;
        text-decoration: underline;
        cursor: pointer;
    }

    .accountNotLoggedIn_stamps{
        border-top: 1px solid var(--gray-100);
        padding: 20px 10px;
        margin-top: 40px;
    }
</style>